import * as PropTypes from 'prop-types';

/** @deprecated */
export interface DeprecatedFolder {
  api_identifier: string;
  name: string;
  source: {};
  url: string;
}

/** @deprecated */
export const DEPRECATED_FOLDER_SHAPE = PropTypes.shape({
  api_identifier: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  source: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired,
});
